module.exports = __webpack_public_path__ + "media/kojic-medium.170ef433.mp4";